import type { PropertyStoryData } from '../types';

type Props = {
  data: PropertyStoryData;
  propertyName: string;
};

export default function PropertyStory({ data, propertyName }: Props) {
  return (
    <section className="bg-background-50 py-20 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.24em] text-accent-700 mb-6">
              <span className="inline-block w-5 h-px bg-accent-500 align-middle mr-3" />
              The property
            </div>

            <h2 className="font-heading text-foreground-950 text-4xl md:text-5xl leading-[1.07] tracking-[-0.01em] mb-8">
              {data.heading ?? propertyName}
              <span className="block italic font-light text-foreground-600 text-3xl md:text-4xl mt-1">
                {data.subheading ?? ' everything you&rsquo;d want.'}
              </span>
            </h2>

            <div className="space-y-6 text-foreground-600 text-base md:text-lg font-light leading-relaxed max-w-2xl">
              {data.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="bg-background-100/60 border border-background-200/80 rounded-2xl p-8 space-y-8">
              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-foreground-500 mb-4">
                  The location
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {data.locationContext}
                </p>
              </div>
              <div className="border-t border-background-200/80 pt-6">
                <p className="text-[11px] uppercase tracking-[0.22em] text-foreground-500 mb-4">
                  The address
                </p>
                <p className="font-heading text-2xl text-foreground-950 leading-tight">
                  {data.address}
                </p>
                <p className="text-sm text-foreground-600 mt-1">{data.addressSub}</p>
              </div>
              <div className="border-t border-background-200/80 pt-6">
                <p className="text-[11px] uppercase tracking-[0.22em] text-foreground-500 mb-4">
                  The property
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {data.propertyMeta}
                </p>
              </div>
              <a
                href="#booking"
                className="block w-full text-center bg-foreground-950 text-background-50 px-5 py-4 rounded-lg text-sm cursor-pointer hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                Book This Property
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
